<div class="modal-header">
    <h1 mat-dialog-title>{{title}}</h1>
</div>

<div *ngIf="action !== 'delete'; else deleteTemplate" mat-dialog-content>
    <form [formGroup]="formData" class="modal-form">

        <ng-container *ngFor="let key of visibleKeys; let i = index">
            <ng-container [ngSwitch]="data.fieldTypes?.[key] ?? 'input'">

                <!-- Input -->
                <mat-form-field *ngSwitchCase="'input'" appearance="fill" class="full-width mt-12">
                    <mat-label>{{labels[key] || key}}</mat-label>
                    <input matInput [formControlName]="key"/>
                    <mat-error *ngIf="formData.get(key)?.hasError('pattern')">
                        Non sono ammessi spazi, maiuscole, caratteri speciali e “-/_” all’inizio o alla fine del nome.
                    </mat-error>

                    <mat-error *ngIf="formData.get(key)?.hasError('required') && formData.get(key)?.touched">
                        Il campo è obbligatorio
                    </mat-error>
                </mat-form-field>

                <!-- Slider + number -->
                <div *ngSwitchCase="'slider'" class="slider-container mt-12">
                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>{{labels[key] || key}}</mat-label>
                        <input matInput type="number" [value]="formData.get(key)?.value ?? 0" (input)="onSliderNumberInput(key, $event)" required />
                        <mat-error *ngIf="formData.get(key)?.invalid && formData.get(key)?.touched">Il campo è obbligatorio
                        </mat-error>
                    </mat-form-field>

                    <mat-slider min="0" max="100" step="0.1" thumbLabel class="full-width">
                        <input matSliderThumb [formControlName]="key" />
                    </mat-slider>
                </div>

                <!-- Select -->
                <mat-form-field *ngSwitchCase="'select'" appearance="fill" class="full-width mt-12">
                    <mat-label>{{labels[key] || key}}</mat-label>
                    <mat-select [formControlName]="key" required panelClass="custom-select-panel">
                        <mat-option *ngFor="let opt of data.selectOptions?.[key] ?? []" [value]="opt.value">
                            {{opt.label}}</mat-option>
                        <!-- Se torna array vuoto -->
                        <mat-option *ngIf="!data.loadingSelect?.[key] && !data.errorSelect?.[key] && (!data.selectOptions?.[key]?.length)" [disabled]="true">Non ci sono elementi da selezionare</mat-option>
                        <!-- Se caricamento in corso -->
                        <mat-option *ngIf="data.loadingSelect?.[key]" [disabled]="true">Caricamento in corso...</mat-option>
                        <!-- Se errore -->
                        <mat-option *ngIf="data.errorSelect?.[key]" [disabled]="true" class="error-option">
                            <mat-icon color="warn" class="error-icon">error_outline</mat-icon>
                            <span class="error-text">Errore nel caricamento degli elementi</span>
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="formData.get(key)?.invalid && formData.get(key)?.touched">Il campo è obbligatorio
                    </mat-error>
                </mat-form-field>

                <!-- Datepicker -->
                <mat-form-field *ngSwitchCase="'date'" appearance="fill" class="full-width mt-12">
                    <mat-label>{{labels[key] || key}}</mat-label>
                    <input matInput [matDatepicker]="picker" [formControlName]="key" required readonly/>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error *ngIf="formData.get(key)?.invalid && formData.get(key)?.touched">Il campo è obbligatorio
                    </mat-error>
                </mat-form-field>

                <!-- Checkbox -->
                <mat-checkbox *ngSwitchCase="'checkbox'" [formControlName]="key">
                    {{labels[key] || key}}
                </mat-checkbox>

            </ng-container>

        </ng-container>

    </form>
</div>

<ng-template #deleteTemplate>
    <app-delete-modal [data]="data"></app-delete-modal>
</ng-template>

<div mat-dialog-actions class="button-actions">
    <button mat-stroked-button class=" btn-outlined-primary" (click)="onModalClose()" matTooltip="Annulla" aria-label="Annulla">Annulla</button>
    <button mat-flat-button color="primary" class="btn-primary" [disabled]="formData.invalid && action !== 'delete'" (click)="onModalSave()" [matTooltip]="action === 'delete' ? 'Conferma' : 'Salva'" [attr.aria-label]="action === 'delete' ? 'Conferma' : 'Salva'">
        {{action === 'delete' ? 'Conferma' : 'Salva'}}
    </button>
</div>